import React from 'react';

export type MembershipCreditLine = {
  text: string;
};

export type MembershipPriceRow = {
  label: string;
  amount: string;
};

export type MembershipSummaryData = {
  planName?: string;
  durationLine?: string | null;
  creditLines?: MembershipCreditLine[];
  priceRows?: MembershipPriceRow[];
};

type Props = {
  data: MembershipSummaryData;
};

function CreditLines({ lines }: { lines: MembershipCreditLine[] }) {
  if (lines.length === 0) {
    return null;
  }

  return (
    <p>
      {lines.map((line, index) => (
        <span key={`credit-${index}`}>
          {index > 0 ? <br /> : null}
          {line.text}
        </span>
      ))}
    </p>
  );
}

function PriceRows({ rows }: { rows: MembershipPriceRow[] }) {
  if (rows.length === 0) {
    return null;
  }

  return (
    <ul className="list no-bottom-border">
      {rows.map((row, index) => (
        <li key={`price-${index}`}>
          <div className="list-text-left">
            <p>
              <b>{row.label}</b>
            </p>
          </div>
          <div className="list-text-right">
            <p>{row.amount}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}

function isEmpty(data: MembershipSummaryData) {
  const { planName, durationLine, creditLines = [], priceRows = [] } = data;

  return (
    !planName && !durationLine && creditLines.length === 0 && priceRows.length === 0
  );
}

export function MembershipSummary({ data }: Props) {
  if (!data || isEmpty(data)) {
    return null;
  }

  const { planName, durationLine, creditLines = [], priceRows = [] } = data;

  return (
    <div className="content-group-extra">
      {planName ? (
        <p>
          <b>{planName}</b>
        </p>
      ) : null}
      {durationLine ? <p>{durationLine}</p> : null}
      <CreditLines lines={creditLines} />
      <PriceRows rows={priceRows} />
    </div>
  );
}
